import { ModelFamily, SharedEndpointModelFamily } from '@/graphql';
import { defaultTheme } from '@/theme';

import CanopyIcon from './Icons/Canopy';
import DeepSeekIcon from './Icons/DeepSeek';
import InceptionIcon from './Icons/Inception';
import KimiIcon from './Icons/Kimi';
import MetaIcon from './Icons/Meta';
import OpenAIIcon from './Icons/OpenAI';
import QwenIcon from './Icons/Qwen';
import ZaiIcon from './Icons/Zai';
import { SharedEndpointIconSize } from './Icons/types';

function mapModelFamilyToIcon(modelFamily: SharedEndpointModelFamily | ModelFamily) {
  switch (modelFamily) {
    case SharedEndpointModelFamily.Deepseek:
      return DeepSeekIcon;
    case SharedEndpointModelFamily.Meta:
      return MetaIcon;
    case SharedEndpointModelFamily.Canopy:
      return CanopyIcon;
    case SharedEndpointModelFamily.Kimi:
      return KimiIcon;
    case SharedEndpointModelFamily.Qwen:
      return QwenIcon;
    case SharedEndpointModelFamily.Openai:
      return OpenAIIcon;
    case SharedEndpointModelFamily.Inception:
      return InceptionIcon;
    case SharedEndpointModelFamily.Zai:
      return ZaiIcon;
    default:
      // TODO: Add other model families
      return MetaIcon;
  }
}

function mapModelFamilyToIconContainerColor(modelFamily: SharedEndpointModelFamily): string {
  // TODO (Aaron): fix the colors
  switch (modelFamily) {
    case SharedEndpointModelFamily.Deepseek:
      return '#4D6BFE';
    case SharedEndpointModelFamily.Meta:
      return '#0081FB';
    case SharedEndpointModelFamily.Kimi:
      return '#000000';
    case SharedEndpointModelFamily.Qwen:
      return '#665BE6';
    case SharedEndpointModelFamily.Openai:
      return '#000000';
    case SharedEndpointModelFamily.Canopy:
      return defaultTheme.palette.background.subtle;
    case SharedEndpointModelFamily.Inception:
      return '#000000';
    case SharedEndpointModelFamily.Zai:
      return '#000000';
    default:
      return '#CCCCCC';
  }
}

function mapModelFamilyToIconColor(modelFamily: SharedEndpointModelFamily): string {
  // TODO (Aaron): fix the colors
  switch (modelFamily) {
    case SharedEndpointModelFamily.Deepseek:
      return defaultTheme.palette.common.white;
    case SharedEndpointModelFamily.Meta:
      return defaultTheme.palette.common.white;
    default:
      return defaultTheme.palette.common.white;
  }
}

function mapIconSizeToSize(size: SharedEndpointIconSize): [number, number] {
  // TODO (Aaron): fix the colors
  switch (size) {
    case SharedEndpointIconSize.XSMALL:
      return [20, 12];
    case SharedEndpointIconSize.SMALL:
      return [28, 16];
    case SharedEndpointIconSize.MEDIUM:
      return [32, 18];
    case SharedEndpointIconSize.LARGE:
      return [75, 43];
  }
}

export {
  mapModelFamilyToIcon,
  mapModelFamilyToIconContainerColor,
  mapModelFamilyToIconColor,
  mapIconSizeToSize,
};
